import { css } from '@/styled-system/css';

export const tour3dButtonStyles = css({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '4px',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: '{colors.hpxTeal700}',
  color: '{colors.hpxTeal700}',
  backgroundColor: '{colors.hpxWhite}',
  fontSize: 'sm',
  width: '60px',
  height: '32px',
  opacity: '0.9',
  md: {
    width: '80px',
  },
  _hover: {
    backgroundColor: '{colors.hpxGrey100}',
  },
  _active: {
    backgroundColor: '{colors.hpxGrey400}',
  },
});

export const tour3dButtonIconStyles = css({
  width: '12px',
  height: '12px',
  borderRadius: '3px',
  md: {
    width: '14px',
    height: '14px',
  },
});

export const tour3dButtonTourTextStyles = css({
  display: 'none',
  md: {
    letterSpacing: '0.5px',
    lineHeight: '0.71',
    textAlign: 'center',
    marginLeft: '4.5px',
    display: 'flex',
  },
});

export const tour3dButton3dTextStyles = css({
  lineHeight: '0.83',
  letterSpacing: '0.5px',
  textAlign: 'center',
  marginLeft: '4.5px',
  display: 'flex',
  md: {
    display: 'none',
  },
});
